import React from 'react';
import ValidationAlert from '../components/ValidationAlert';
import utils from '../../../utils';
import { getLabel, getLabelAsString } from '../formRenderHelper';

function TextareaInput({ control, handleChange, formOption }) {
    const { name, label, type, value, errors, style } = control;
    const fieldId = utils.random.shortId();
    const fieldLabel = getLabel(control, formOption);
    //const { template = 'bootstrap', usePlaceholder = false } = formOption;
    const { usePlaceholder = false } = formOption;
    const placeHolder = usePlaceholder ? getLabelAsString(control, formOption) : null;
    const valueStr = value === 0 ? 0 : (value || "");
    return (
        <div className={`ff ff--textarea form-group ${style && style.className}`}>
            {!usePlaceholder && fieldLabel && <label htmlFor={fieldId} className="label">{fieldLabel}</label>}
            <div className="ff__input">
                <textarea id={fieldId} name={name} value={valueStr} type={type} onChange={(e) => handleChange(e, control)}
                    placeholder={placeHolder}
                    rows={style && style.rows}
                    className={"form-control" + (errors && errors.length > 0 ? ' is-invalid' : '')}></textarea>
            </div>
            <ValidationAlert errors={errors} />
        </div>
    )
}

export default TextareaInput;